import "./utilities_namespace.js";

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

Sparkle.Utilities.scrollToTop = function (targetSelector, options) {
  options = jQuery.extend(
    {
      duration: "slow",
      ifNecessary: false,
      padding: 0,
    },
    options,
  );

  var target = jQuery(targetSelector);

  if (!target.length) {
    return;
  }

  var parent = Sparkle.Utilities.getScrollParent(target);

  if (options.ifNecessary) {
    var parentTop = parent.offset().top + parent.scrollTop();
    var viewportHeight = Math.min(parent.prop("offsetHeight"), window.innerHeight);
    var targetTop = target.offset().top;

    if (parentTop + options.padding < targetTop && targetTop < parentTop + viewportHeight - options.padding) {
      return;
    }
  }

  parent.animate(
    {
      scrollTop: target.offset().top - options.padding - parent.offset().top,
    },
    options.duration,
  );
};

Sparkle.Utilities.getScrollParent = function (element, includeHidden) {
  element = jQuery(element)[0];

  var excludeStaticParent, overflowRegex, parent, style;
  style = getComputedStyle(element);

  if (style.position === "fixed") {
    return jQuery(document.body);
  }

  excludeStaticParent = style.position === "absolute";
  overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
  parent = element;

  while (parent) {
    var nextParent;

    // If the element is slotted into a shadow DOM, follow the composed tree
    // via assignedSlot instead of the light DOM tree via parentElement.
    if (parent.assignedSlot) {
      nextParent = parent.assignedSlot;
    } else {
      nextParent = parent.parentElement;
    }

    // Cross shadow DOM boundary if we've reached the top of a shadow tree
    if (!nextParent) {
      var root = parent.getRootNode();
      if (root instanceof ShadowRoot) {
        nextParent = root.host;
      }
    }

    parent = nextParent;
    if (!parent) {
      break;
    }

    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) {
      return jQuery(parent);
    }
  }
  return jQuery(document.body);
};
